import { JotForm } from "./JotForm";
import { jsx as _jsx } from "react/jsx-runtime";
export var Form = _ref => {
  var {
    id
  } = _ref;
  return /*#__PURE__*/_jsx("section", {
    className: "w-full",
    children: id ? /*#__PURE__*/_jsx(JotForm, {
      src: "https://forms.cancerqld.org.au/" + id
    }) : null
  });
};
//# sourceMappingURL=index.js.map